export const GET_BASE_PACKAGES = 'GET_BASE_PACKAGES';
export const UPDATE_BASE_PACKAGES = 'UPDATE_BASE_PACKAGES';
export const GET_CUSTOM_PACKAGES = 'GET_CUSTOM_PACKAGES';
export const UPDATE_CUSTOM_PACKAGES = 'UPDATE_CUSTOM_PACKAGES';
export const SET_PACKAGES_LOADING = 'SET_PACKAGES_LOADING';

export const SHOW_CREATE_PACKAGE_MODAL = 'SHOW_CREATE_PACKAGE_MODAL';
export const SHOW_EDIT_PACKAGE_MODAL = 'SHOW_EDIT_PACKAGE_MODAL';
export const SET_PACKAGE_EDITOR_LOADING = 'SET_PACKAGE_EDITOR_LOADING';
export const SET_PACKAGE_EDITOR_ERROR = 'SET_PACKAGE_EDITOR_ERROR';
export const SAVE_PACKAGE = 'SAVE_PACKAGE';

export const SHOW_DELETE_CONFIRMATION = 'SHOW_DELETE_CONFIRMATION';
export const DELETE_PACKAGE = 'DELETE_PACKAGE';
export const SET_DELETE_LOADING = 'SET_DELETE_LOADING';

export const GET_TERRITORIES = 'GET_TERRITORIES';
export const UPDATE_TERRITORIES = 'UPDATE_TERRITORIES';

export const GET_LEAD_SOURCES = 'GET_LEAD_SOURCES';
export const UPDATE_LEAD_SOURCES = 'UPDATE_LEAD_SOURCES';

export const GET_BONUS_SUBSCRIPTION_TYPES = 'GET_BONUS_SUBSCRIPTION_TYPES';
export const UPDATE_BONUS_SUBSCRIPTION_TYPES =
  'UPDATE_BONUS_SUBSCRIPTION_TYPES';

export const BILLING_PACKAGE_DO_SHOW_LOG = 'BILLING_PACKAGE_DO_SHOW_LOG';
export const BILLING_PACKAGE_LOG_SET_SHOWN = 'BILLING_PACKAGE_LOG_SET_SHOWN';
export const BILLING_PACKAGE_LOG_CHANGE_PAGE =
  'BILLING_PACKAGE_LOG_CHANGE_PAGE';
export const BILLING_PACKAGE_LOG_SET_DATA = 'BILLING_PACKAGE_LOG_SET_DATA';
export const BILLING_PACKAGE_LOG_SET_IS_LOADING =
  'BILLING_PACKAGE_LOG_SET_IS_LOADING';
export const BILLING_PACKAGE_LOG_SET_ERRORS = 'BILLING_PACKAGE_LOG_SET_ERRORS';
